module.exports = __webpack_public_path__ + "static/media/8767.4cf82a33.png";